// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  scrollbar-color: var(--ion-border-color) black;
}
@media only screen and (min-width: 1025px) {
  :host ion-app.ion-page {
    max-width: 620px;
    margin-left: auto;
    margin-right: auto;
  }
}
:host ::ng-deep .hint-highlight {
  background: #505050 !important;
  --background: #505050;
}
:host ::ng-deep .hint-highlight.rounded {
  border-radius: 50% !important;
}

ion-footer {
  height: calc(var(--footer-menu-height) + var(--app-safe-area-bottom));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  position: fixed;
  bottom: 0;
  display: flex;
  width: 100%;
  background: transparent;
  overflow: visible;
  z-index: 10;
  isolation: isolate;
}
ion-footer .footer-bg {
  position: absolute;
  inset: 0;
  background: rgba(var(--color-black-rgb), 0.2);
  backdrop-filter: blur(var(--footer-menu-blur));
  -webkit-backdrop-filter: blur(var(--footer-menu-blur));
  pointer-events: none;
  z-index: 0;
}
ion-footer .footer-nav {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  padding: 0 73px calc(var(--app-safe-area-bottom) + 10px);
}
ion-footer .menu-item {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
ion-footer .menu-item > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
ion-footer .menu-item .icon {
  height: 24px;
  width: 24px;
  stroke: var(--nav-btn-icon-color);
  stroke-opacity: var(--nav-btn-icon-opacity);
  color: var(--nav-btn-icon-color);
}
ion-footer .menu-item .menu-icon-wrap {
  position: relative;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
ion-footer .menu-item .menu-icon {
  width: 30px;
  height: 30px;
  position: absolute;
  bottom: -1px;
}
ion-footer .menu-item .producer-action {
  position: relative;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: #eef4ff;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(var(--footer-menu-blur));
  -webkit-backdrop-filter: blur(var(--footer-menu-blur));
  border: 2px solid rgba(255, 255, 255, 0.65);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.32);
  transition: width 0.2s ease, height 0.2s ease, box-shadow 0.2s ease;
  will-change: width, height;
}
ion-footer .menu-item .producer-action::before {
  content: "";
  position: absolute;
  inset: 0;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.08);
  pointer-events: none;
}
ion-footer .menu-item .producer-action .icon-inner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
ion-footer .menu-item .main-action-text {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.4px;
  text-align: center;
  text-transform: uppercase;
  color: #f8fbff;
  width: 50px;
  user-select: none !important;
  -webkit-user-select: none !important;
  -webkit-touch-callout: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  position: relative;
  z-index: 1;
  white-space: normal;
  word-break: break-word;
}
ion-footer .menu-item.selected .icon {
  stroke-opacity: var(--nav-btn-selected-icon-opacity);
}
ion-footer .menu-item.main-action {
  justify-self: center;
  transform: translateY(-22px);
  transition: transform 0.2s ease;
  will-change: transform;
}
ion-footer .menu-item.menu-item-left {
  justify-self: start;
}
ion-footer .menu-item.menu-item-right {
  justify-self: end;
}
ion-footer .menu-item .unread-messages::after {
  right: 10px;
  content: "";
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: red;
  top: 0;
}
ion-footer .menu-item .executor-online-indicator::after {
  left: 30px;
  content: "";
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #33D256;
  top: 0;
}
ion-footer .menu-item .unread-notifications::after {
  right: -3px;
  content: "";
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: red;
  top: 0;
}
ion-footer .menu-item .menu-alert-indicator {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #FF3B30;
  box-shadow: 0 0 8px rgba(255, 59, 48, 0.7);
}
ion-footer.footer-compact .menu-item.main-action {
  transform: translateY(-4px);
}

:host ::ng-deep ion-menu.main-drawer {
  --width: min(82vw, 360px);
  --max-width: 360px;
  --background: transparent;
}

:host ::ng-deep ion-menu.main-drawer::part(container) {
  background: linear-gradient(155deg, rgba(27, 34, 46, 0.76), rgba(14, 18, 28, 0.92));
  border-right: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 12px 0 26px rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(24px) saturate(140%);
  -webkit-backdrop-filter: blur(24px) saturate(140%);
}

:host ::ng-deep ion-menu.main-drawer::part(backdrop) {
  background: rgba(9, 11, 18, 0.45);
}

.drawer-content {
  --background: transparent;
  background: transparent;
  color: #f5f7fa;
}

:host ::ng-deep ion-menu.main-drawer ion-content.drawer-content::part(scroll) {
  position: relative;
}

.drawer-header {
  padding: calc(var(--ion-safe-area-top, 0) + 16px) 20px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0));
}

.drawer-user {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 14px;
  cursor: pointer;
}

:host ::ng-deep .drawer-user user-avatar {
  width: 64px;
  height: 64px;
  flex: 0 0 64px;
}

.drawer-user-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 6px;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
}

.drawer-name {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

.drawer-status {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.drawer-list {
  padding: 12px 10px calc(20px + var(--app-safe-area-bottom));
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.drawer-list--with-downloads {
  padding-bottom: calc(260px + var(--app-safe-area-bottom));
}

.drawer-group {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 14px;
  overflow: hidden;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.drawer-group--solo {
  margin: 0;
}

.drawer-item {
  --background: transparent;
  --background-hover: rgba(255, 255, 255, 0.7);
  --background-activated: rgba(255, 255, 255, 0.12);
  --border-radius: 0;
  --padding-start: 14px;
  --padding-end: 14px;
  --min-height: 50px;
  --inner-border-width: 0;
  --border-width: 0;
  color: #e8edf5;
  border-radius: 0;
  margin: 0;
  border: none;
}
.drawer-item ion-icon {
  color: #9fb1c9;
  stroke: currentColor;
  fill: none;
}
.drawer-item.selected {
  --background: linear-gradient(135deg, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0.08));
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}
.drawer-item.selected ion-icon {
  color: #ffffff;
}

.drawer-item--disabled {
  opacity: 0.6;
  cursor: default;
}

.drawer-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ff3b30;
  display: inline-block;
  box-shadow: 0 0 8px rgba(255, 59, 48, 0.7);
}

.drawer-downloads {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: calc(var(--app-safe-area-bottom, 0px) + 10px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: linear-gradient(180deg, rgba(20, 28, 43, 0.98) 0%, rgba(13, 19, 31, 0.98) 100%);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.36);
  overflow: hidden;
  z-index: 2;
}

.drawer-downloads__header {
  padding: 12px 14px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 10px;
}

.drawer-downloads__title {
  font-size: 13px;
  line-height: 1.35;
  font-weight: 600;
  color: #eef4ff;
}

.drawer-downloads__counter {
  min-width: 24px;
  height: 24px;
  padding: 0 7px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 1;
  font-weight: 700;
  color: #f7faff;
  background: rgba(142, 194, 255, 0.22);
}

.drawer-downloads__list {
  max-height: min(36vh, 230px);
  overflow-y: auto;
}

.drawer-downloads__item {
  min-height: 44px;
  padding: 8px 14px;
  display: grid;
  align-items: center;
  grid-template-columns: minmax(0, 1fr) auto auto;
  column-gap: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(255, 255, 255, 0);
  transition: background-color 0.12s ease;
}

.drawer-downloads__item:active {
  background: rgba(255, 255, 255, 0.04);
}

.drawer-downloads__item:last-child {
  border-bottom: 0;
}

.drawer-downloads__file-name {
  font-size: 12px;
  line-height: 1.3;
  color: #e8edf5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.drawer-downloads__progress {
  font-size: 12px;
  line-height: 1;
  color: rgba(239, 244, 255, 0.88);
}

.drawer-downloads__cancel {
  border: 1px solid rgba(142, 194, 255, 0.2);
  border-radius: 10px;
  padding: 5px 8px;
  font-size: 12px;
  line-height: 1;
  font-weight: 600;
  color: #8ec2ff;
  background: rgba(142, 194, 255, 0.08);
}

.drawer-downloads__cancel:active {
  background: rgba(142, 194, 255, 0.2);
}

.downloads-fab {
  position: fixed;
  left: 12px;
  bottom: calc(var(--app-safe-area-bottom, 0px) + 12px);
  width: 58px;
  height: 58px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  padding: 0;
  background: radial-gradient(circle at 30% 24%, rgba(46, 63, 92, 0.98) 0%, rgba(16, 24, 38, 0.98) 100%);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);
  color: #f8fbff;
  z-index: 20;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transition: transform 0.12s ease, box-shadow 0.12s ease;
}

.downloads-fab:active {
  transform: scale(0.97);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.38);
}

.downloads-fab__ring {
  width: 58px;
  height: 58px;
  transform: rotate(-90deg);
}

.downloads-fab__track,
.downloads-fab__progress {
  fill: none;
  stroke-width: 4;
}

.downloads-fab__track {
  stroke: rgba(255, 255, 255, 0.2);
}

.downloads-fab__progress {
  stroke: #7ec0ff;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.2s linear;
}

.downloads-fab__label {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.desktop-install-fab {
  position: fixed;
  right: 12px;
  bottom: calc(var(--app-safe-area-bottom, 0px) + 12px);
  min-height: 42px;
  max-width: min(220px, 100vw - 24px);
  padding: 10px 14px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: linear-gradient(135deg, rgba(56, 89, 134, 0.98) 0%, rgba(20, 38, 66, 0.98) 100%);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);
  color: #f8fbff;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.15;
  letter-spacing: 0.01em;
  z-index: 20;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transition: transform 0.12s ease, box-shadow 0.12s ease;
}

.desktop-install-fab:active {
  transform: scale(0.98);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.38);
}

.hint {
  position: fixed;
  background: #0057FF;
  width: 264px;
  min-height: 180px;
  padding: 12px;
  border-radius: 7px;
  z-index: 9991;
}
.hint.hint--hidden {
  opacity: 0;
}
.hint .next-tip, .hint .close-tip {
  margin-top: 2px;
}
.hint .header {
  margin-top: 0;
}
.hint .header.top-offset {
  margin-top: 30px;
}
.hint .text {
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 25px;
}
.hint .close-btn {
  float: right;
  cursor: pointer;
  width: 50px;
  height: 25px;
  text-align: right;
}
.hint::after {
  content: " ";
  position: absolute;
  height: 0;
  width: 0;
  border: 12px solid transparent;
}
.hint.right-arrow::after {
  left: 100%;
  top: var(--hint-arrow-offset);
  border-left: 15px solid #0057FF;
}
.hint.left-arrow::after {
  right: 100%;
  top: var(--hint-arrow-offset);
  border-right: 15px solid #0057FF;
}
.hint.top-arrow::after {
  bottom: 100%;
  left: var(--hint-arrow-offset);
  border-bottom: 15px solid #0057FF;
}
.hint.bottom-arrow::after {
  top: 100%;
  left: var(--hint-arrow-offset);
  border-top: 15px solid #0057FF;
}

.hint-bg {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9990;
}

.swiper-pagination {
  width: calc(100% - 30px);
  bottom: calc(100% - 28px);
  position: relative;
  text-align: left;
  margin-bottom: -20px;
}

.swiper-button-next {
  width: calc(100% - 30px);
  top: auto;
  bottom: 5px;
  right: 5px;
  margin: 10px;
  cursor: pointer;
}
.swiper-button-next svg {
  margin-left: auto;
}

.swiper-button-next::after,
.swiper-button-prev::after {
  content: none;
}

.swiper-button-prev {
  width: auto;
  top: auto;
  bottom: 5px;
  left: 5px;
  margin: 10px;
  cursor: pointer;
}

.swiper-button-next.hidden,
.swiper-button-prev.hidden {
  display: none;
}

.swiper-button-disabled {
  opacity: 0;
  display: none;
}

.slider {
  --swiper-pagination-color: white;
  --swiper-pagination-bullet-opacity: 1;
  --swiper-navigation-color: white;
  --swiper-navigation-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;AADF;AAGE;EACE;IACE,gBAAA;IACA,iBAAA;IACA,kBAAA;EADJ;AACF;AAKI;EACE,8BAAA;EACA,qBAAA;AAHN;AAMI;EACE,6BAAA;AAJN;;AASA;EACE,qEAAA;EACA,yBAAA;EACA,0BAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AANF;AAQE;EACE,kBAAA;EACA,QAAA;EACA,6CAAA;EACA,8CAAA;EACA,sDAAA;EACA,oBAAA;EACA,UAAA;AANJ;AASE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mCAAA;EACA,wDAAA;AAPJ;AAUE;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AARJ;AAUI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AARN;AAWI;EACE,YAAA;EACA,WAAA;EACA,iCAAA;EACA,2CAAA;EACA,gCAAA;AATN;AAYI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAVN;AAaI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AAXN;AAcI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,8BAAA;EACA,8CAAA;EACA,sDAAA;EACA,2CAAA;EACA,2CAAA;EACA,mEAAA;EACA,0BAAA;AAZN;AAcM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,qCAAA;EACA,oBAAA;AAZR;AAgBI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAdN;AAiBI;EACE,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;EC/IJ,4BAAA;EACA,oCAAA;EACA,sCAAA;EACA,iCAAA;EACA,gCAAA;ED6II,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;AAXN;AAeM;EACE,oDAAA;AAbR;AAiBI;EACE,oBAAA;EACA,4BAAA;EACA,+BAAA;EACA,sBAAA;AAfN;AAkBI;EACE,mBAAA;AAhBN;AAmBI;EACE,iBAAA;AAjBN;AA8BI;EACE,WAAA;EAVA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAM0B;EAL1B,MAAA;AAjBN;AAyBI;EACE,UAAA;EAfA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAW0B;EAV1B,MAAA;AAPN;AAoBI;EACE,WAAA;EApBA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAgB0B;EAf1B,MAAA;AAGN;AAeI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,0CAAA;AAbN;AAkBI;EACE,2BAAA;AAhBN;;AAqBA;EACE,yBAAA;EACA,kBAAA;EACA,yBAAA;AAlBF;;AAqBA;EACE,mFAAA;EACA,iDAAA;EACA,0CAAA;EACA,0CAAA;EACA,kDAAA;AAlBF;;AAqBA;EACE,iCAAA;AAlBF;;AAqBA;EACE,yBAAA;EACA,uBAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,kBAAA;AAlBF;;AAqBA;EACE,2DAAA;EACA,kDAAA;EACA,sFAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,2DAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAlBF;;AAqBA;EACE,yDAAA;AAlBF;;AAqBA;EACE,qCAAA;EACA,2CAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;EACA,mCAAA;AAlBF;;AAqBA;EACE,SAAA;AAlBF;;AAqBA;EACE,yBAAA;EACA,4CAAA;EACA,iDAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;AAlBF;AAoBE;EACE,cAAA;EACA,oBAAA;EACA,UAAA;AAlBJ;AAqBE;EACE,2FAAA;EACA,oDAAA;AAnBJ;AAqBI;EACE,cAAA;AAnBN;;AAwBA;EACE,YAAA;EACA,eAAA;AArBF;;AAwBA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,0CAAA;AArBF;;AAwBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qDAAA;EACA,mBAAA;EACA,2CAAA;EACA,2FAAA;EACA,2CAAA;EACA,gBAAA;EACA,UAAA;AArBF;;AAwBA;EACE,uBAAA;EACA,iDAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AArBF;;AAwBA;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,qCAAA;AArBF;;AAwBA;EACE,4BAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,+CAAA;EACA,gBAAA;EACA,kDAAA;EACA,kCAAA;EACA,uCAAA;AArBF;;AAwBA;EACE,qCAAA;AArBF;;AAwBA;EACE,gBAAA;AArBF;;AAwBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AArBF;;AAwBA;EACE,eAAA;EACA,cAAA;EACA,gCAAA;AArBF;;AAwBA;EACE,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,qCAAA;AArBF;;AAwBA;EACE,oCAAA;AArBF;;AAwBA;EACE,eAAA;EACA,UAAA;EACA,qDAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,UAAA;EACA,sGAAA;EACA,2CAAA;EACA,cAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;EACA,uDAAA;AArBF;;AAwBA;EACE,sBAAA;EACA,0CAAA;AArBF;;AAwBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AArBF;;AAwBA;;EAEE,UAAA;EACA,eAAA;AArBF;;AAwBA;EACE,gCAAA;AArBF;;AAwBA;EACE,eAAA;EACA,qBAAA;EACA,yCAAA;AArBF;;AAwBA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AArBF;;AAwBA;EACE,eAAA;EACA,WAAA;EACA,qDAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,oBAAA;EACA,2CAAA;EACA,4FAAA;EACA,2CAAA;EACA,cAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,0BAAA;EACA,kCAAA;EACA,uDAAA;AArBF;;AAwBA;EACE,sBAAA;EACA,0CAAA;AArBF;;AAyBA;EACE,eAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;AAtBF;AAwBE;EACE,UAAA;AAtBJ;AAyBE;EACE,eAAA;AAvBJ;AA0BE;EACE,aAAA;AAxBJ;AA0BI;EACE,gBAAA;AAxBN;AA4BE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AA1BJ;AA6BE;EACE,YAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA3BJ;AA8BE;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,8BAAA;AA5BJ;AA+BE;EACE,UAAA;EACA,6BAAA;EACA,+BAAA;AA7BJ;AAgCE;EACE,WAAA;EACA,6BAAA;EACA,gCAAA;AA9BJ;AAiCE;EACE,YAAA;EACA,8BAAA;EACA,iCAAA;AA/BJ;AAkCE;EACE,SAAA;EACA,8BAAA;EACA,8BAAA;AAhCJ;;AAoCA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;AAjCF;;AAoCA;EACE,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAjCF;;AAoCA;EACE,wBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AAjCF;AAmCE;EACE,iBAAA;AAjCJ;;AAqCA;;EAEE,aAAA;AAlCF;;AAqCA;EACE,WAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;AAlCF;;AAqCA;;EAEE,aAAA;AAlCF;;AAqCA;EACE,UAAA;EACA,aAAA;AAlCF;;AAqCA;EACE,gCAAA;EACA,qCAAA;EACA,gCAAA;EACA,8BAAA;AAlCF","sourcesContent":["@use '../styles/mixins' as *;\n\n:host {\n  scrollbar-color: var(--ion-border-color) black;\n\n  @media only screen and (min-width: 1025px) {\n    ion-app.ion-page {\n      max-width: 620px;\n      margin-left: auto;\n      margin-right: auto;\n    }\n  }\n\n  ::ng-deep {\n    .hint-highlight {\n      background: #505050 !important;\n      --background: #505050;\n    }\n\n    .hint-highlight.rounded {\n      border-radius: 50% !important;\n    }\n  }\n}\n\nion-footer {\n  height: calc(var(--footer-menu-height) + var(--app-safe-area-bottom));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  position: fixed;\n  bottom: 0;\n  display: flex;\n  width: 100%;\n  background: transparent;\n  overflow: visible;\n  z-index: 10;\n  isolation: isolate;\n\n  .footer-bg {\n    position: absolute;\n    inset: 0;\n    background: rgba(var(--color-black-rgb), 0.2);\n    backdrop-filter: blur(var(--footer-menu-blur));\n    -webkit-backdrop-filter: blur(var(--footer-menu-blur));\n    pointer-events: none;\n    z-index: 0;\n  }\n\n  .footer-nav {\n    position: relative;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n    display: grid;\n    grid-template-columns: 1fr auto 1fr;\n    padding: 0 73px calc(var(--app-safe-area-bottom) + 10px);\n  }\n\n  .menu-item {\n    position: relative;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    & > div {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      gap: 4px;\n    }\n\n    .icon {\n      height: 24px;\n      width: 24px;\n      stroke: var(--nav-btn-icon-color);\n      stroke-opacity: var(--nav-btn-icon-opacity);\n      color: var(--nav-btn-icon-color);\n    }\n\n    .menu-icon-wrap {\n      position: relative;\n      width: 30px;\n      height: 30px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .menu-icon {\n      width: 30px;\n      height: 30px;\n      position: absolute;\n      bottom: -1px;\n    }\n\n    .producer-action {\n      position: relative;\n      width: 64px;\n      height: 64px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      overflow: hidden;\n      color: #eef4ff;\n      background: rgba(0, 0, 0, 0.3);\n      backdrop-filter: blur(var(--footer-menu-blur));\n      -webkit-backdrop-filter: blur(var(--footer-menu-blur));\n      border: 2px solid rgba(255, 255, 255, 0.65);\n      box-shadow: 0 10px 22px rgba(0, 0, 0, 0.32);\n      transition: width 0.2s ease, height 0.2s ease, box-shadow 0.2s ease;\n      will-change: width, height;\n\n      &::before {\n        content: \"\";\n        position: absolute;\n        inset: 0;\n        backdrop-filter: blur(10px);\n        -webkit-backdrop-filter: blur(10px);\n        background: rgba(255, 255, 255, 0.08);\n        pointer-events: none;\n      }\n    }\n\n    .producer-action .icon-inner {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .main-action-text {\n      font-family: 'Inter', sans-serif;\n      font-weight: 600;\n      font-style: normal;\n      font-size: 10px;\n      line-height: 12px;\n      letter-spacing: 0.4px;\n      text-align: center;\n      text-transform: uppercase;\n      color: #f8fbff;\n      width: 50px;\n      @include unselectable;\n      position: relative;\n      z-index: 1;\n      white-space: normal;\n      word-break: break-word;\n    }\n\n    &.selected {\n      .icon {\n        stroke-opacity: var(--nav-btn-selected-icon-opacity);\n      }\n    }\n\n    &.main-action {\n      justify-self: center;\n      transform: translateY(-22px);\n      transition: transform 0.2s ease;\n      will-change: transform;\n    }\n\n    &.menu-item-left {\n      justify-self: start;\n    }\n\n    &.menu-item-right {\n      justify-self: end;\n    }\n\n    @mixin status-indicator($color) {\n      content: \"\";\n      position: absolute;\n      width: 6px;\n      height: 6px;\n      border-radius: 50%;\n      background-color: $color;\n      top: 0;\n    }\n\n    .unread-messages::after {\n      right: 10px;\n      @include status-indicator(red);\n    }\n\n    .executor-online-indicator::after {\n      left: 30px;\n      @include status-indicator(#33D256);\n    }\n\n    .unread-notifications::after {\n      right: -3px;\n      @include status-indicator(red);\n    }\n\n    .menu-alert-indicator {\n      position: absolute;\n      top: -2px;\n      right: -2px;\n      width: 6px;\n      height: 6px;\n      border-radius: 50%;\n      background-color: #FF3B30;\n      box-shadow: 0 0 8px rgba(255, 59, 48, 0.7);\n    }\n  }\n\n  &.footer-compact {\n    .menu-item.main-action {\n      transform: translateY(-4px);\n    }\n  }\n}\n\n:host ::ng-deep ion-menu.main-drawer {\n  --width: min(82vw, 360px);\n  --max-width: 360px;\n  --background: transparent;\n}\n\n:host ::ng-deep ion-menu.main-drawer::part(container) {\n  background: linear-gradient(155deg, rgba(27, 34, 46, 0.76), rgba(14, 18, 28, 0.92));\n  border-right: 1px solid rgba(255, 255, 255, 0.12);\n  box-shadow: 12px 0 26px rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(24px) saturate(140%);\n  -webkit-backdrop-filter: blur(24px) saturate(140%);\n}\n\n:host ::ng-deep ion-menu.main-drawer::part(backdrop) {\n  background: rgba(9, 11, 18, 0.45);\n}\n\n.drawer-content {\n  --background: transparent;\n  background: transparent;\n  color: #f5f7fa;\n}\n\n:host ::ng-deep ion-menu.main-drawer ion-content.drawer-content::part(scroll) {\n  position: relative;\n}\n\n.drawer-header {\n  padding: calc(var(--ion-safe-area-top, 0) + 16px) 20px 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0));\n}\n\n.drawer-user {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 14px;\n  cursor: pointer;\n}\n\n:host ::ng-deep .drawer-user user-avatar {\n  width: 64px;\n  height: 64px;\n  flex: 0 0 64px;\n}\n\n.drawer-user-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n  gap: 6px;\n  flex: 1 1 auto;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.drawer-name {\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.drawer-status {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.65);\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.drawer-list {\n  padding: 12px 10px calc(20px + var(--app-safe-area-bottom));\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.drawer-list--with-downloads {\n  padding-bottom: calc(260px + var(--app-safe-area-bottom));\n}\n\n.drawer-group {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 14px;\n  overflow: hidden;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.drawer-group--solo {\n  margin: 0;\n}\n\n.drawer-item {\n  --background: transparent;\n  --background-hover: rgba(255, 255, 255, 0.7);\n  --background-activated: rgba(255, 255, 255, 0.12);\n  --border-radius: 0;\n  --padding-start: 14px;\n  --padding-end: 14px;\n  --min-height: 50px;\n  --inner-border-width: 0;\n  --border-width: 0;\n  color: #e8edf5;\n  border-radius: 0;\n  margin: 0;\n  border: none;\n\n  ion-icon {\n    color: #9fb1c9;\n    stroke: currentColor;\n    fill: none;\n  }\n\n  &.selected {\n    --background: linear-gradient(135deg, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0.08));\n    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);\n\n    ion-icon {\n      color: #ffffff;\n    }\n  }\n}\n\n.drawer-item--disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.drawer-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #ff3b30;\n  display: inline-block;\n  box-shadow: 0 0 8px rgba(255, 59, 48, 0.7);\n}\n\n.drawer-downloads {\n  position: absolute;\n  left: 10px;\n  right: 10px;\n  bottom: calc(var(--app-safe-area-bottom, 0px) + 10px);\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: linear-gradient(180deg, rgba(20, 28, 43, 0.98) 0%, rgba(13, 19, 31, 0.98) 100%);\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.36);\n  overflow: hidden;\n  z-index: 2;\n}\n\n.drawer-downloads__header {\n  padding: 12px 14px 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  column-gap: 10px;\n}\n\n.drawer-downloads__title {\n  font-size: 13px;\n  line-height: 1.35;\n  font-weight: 600;\n  color: #eef4ff;\n}\n\n.drawer-downloads__counter {\n  min-width: 24px;\n  height: 24px;\n  padding: 0 7px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  line-height: 1;\n  font-weight: 700;\n  color: #f7faff;\n  background: rgba(142, 194, 255, 0.22);\n}\n\n.drawer-downloads__list {\n  max-height: min(36vh, 230px);\n  overflow-y: auto;\n}\n\n.drawer-downloads__item {\n  min-height: 44px;\n  padding: 8px 14px;\n  display: grid;\n  align-items: center;\n  grid-template-columns: minmax(0, 1fr) auto auto;\n  column-gap: 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(255, 255, 255, 0);\n  transition: background-color 0.12s ease;\n}\n\n.drawer-downloads__item:active {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.drawer-downloads__item:last-child {\n  border-bottom: 0;\n}\n\n.drawer-downloads__file-name {\n  font-size: 12px;\n  line-height: 1.3;\n  color: #e8edf5;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.drawer-downloads__progress {\n  font-size: 12px;\n  line-height: 1;\n  color: rgba(239, 244, 255, 0.88);\n}\n\n.drawer-downloads__cancel {\n  border: 1px solid rgba(142, 194, 255, 0.2);\n  border-radius: 10px;\n  padding: 5px 8px;\n  font-size: 12px;\n  line-height: 1;\n  font-weight: 600;\n  color: #8ec2ff;\n  background: rgba(142, 194, 255, 0.08);\n}\n\n.drawer-downloads__cancel:active {\n  background: rgba(142, 194, 255, 0.2);\n}\n\n.downloads-fab {\n  position: fixed;\n  left: 12px;\n  bottom: calc(var(--app-safe-area-bottom, 0px) + 12px);\n  width: 58px;\n  height: 58px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  padding: 0;\n  background: radial-gradient(circle at 30% 24%, rgba(46, 63, 92, 0.98) 0%, rgba(16, 24, 38, 0.98) 100%);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);\n  color: #f8fbff;\n  z-index: 20;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  transition: transform 0.12s ease, box-shadow 0.12s ease;\n}\n\n.downloads-fab:active {\n  transform: scale(0.97);\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.38);\n}\n\n.downloads-fab__ring {\n  width: 58px;\n  height: 58px;\n  transform: rotate(-90deg);\n}\n\n.downloads-fab__track,\n.downloads-fab__progress {\n  fill: none;\n  stroke-width: 4;\n}\n\n.downloads-fab__track {\n  stroke: rgba(255, 255, 255, 0.2);\n}\n\n.downloads-fab__progress {\n  stroke: #7ec0ff;\n  stroke-linecap: round;\n  transition: stroke-dashoffset 0.2s linear;\n}\n\n.downloads-fab__label {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  line-height: 1;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.desktop-install-fab {\n  position: fixed;\n  right: 12px;\n  bottom: calc(var(--app-safe-area-bottom, 0px) + 12px);\n  min-height: 42px;\n  max-width: min(220px, calc(100vw - 24px));\n  padding: 10px 14px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  background: linear-gradient(135deg, rgba(56, 89, 134, 0.98) 0%, rgba(20, 38, 66, 0.98) 100%);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);\n  color: #f8fbff;\n  font-family: 'Inter', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  z-index: 20;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  transition: transform 0.12s ease, box-shadow 0.12s ease;\n}\n\n.desktop-install-fab:active {\n  transform: scale(0.98);\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.38);\n}\n\n//#region hint\n.hint {\n  position: fixed;\n  background: #0057FF;\n  width: 264px;\n  min-height: 180px;\n  padding: 12px;\n  border-radius: 7px;\n  z-index: 9991;\n\n  &.hint--hidden {\n    opacity: 0;\n  }\n\n  .next-tip, .close-tip {\n    margin-top: 2px;\n  }\n\n  .header {\n    margin-top: 0;\n\n    &.top-offset {\n      margin-top: 30px;\n    }\n  }\n\n  .text {\n    font-size: 14px;\n    line-height: 19px;\n    margin-bottom: 25px;\n  }\n\n  .close-btn {\n    float: right;\n    cursor: pointer;\n    width: 50px;\n    height: 25px;\n    text-align: right;\n  }\n\n  &::after {\n    content: \" \";\n    position: absolute;\n    height: 0;\n    width: 0;\n    border: 12px solid transparent;\n  }\n\n  &.right-arrow::after {\n    left: 100%;\n    top: var(--hint-arrow-offset);\n    border-left: 15px solid #0057FF;\n  }\n\n  &.left-arrow::after {\n    right: 100%;\n    top: var(--hint-arrow-offset);\n    border-right: 15px solid #0057FF;\n  }\n\n  &.top-arrow::after {\n    bottom: 100%;\n    left: var(--hint-arrow-offset);\n    border-bottom: 15px solid #0057FF;\n  }\n\n  &.bottom-arrow::after {\n    top: 100%;\n    left: var(--hint-arrow-offset);\n    border-top: 15px solid #0057FF;\n  }\n}\n\n.hint-bg {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 9990;\n}\n\n.swiper-pagination {\n  width: calc(100% - 30px);\n  bottom: calc(100% - 28px);\n  position: relative;\n  text-align: left;\n  margin-bottom: -20px;\n}\n\n.swiper-button-next {\n  width: calc(100% - 30px);\n  top: auto;\n  bottom: 5px;\n  right: 5px;\n  margin: 10px;\n  cursor: pointer;\n\n  svg {\n    margin-left: auto;\n  }\n}\n\n.swiper-button-next::after,\n.swiper-button-prev::after {\n  content: none;\n}\n\n.swiper-button-prev {\n  width: auto;\n  top: auto;\n  bottom: 5px;\n  left: 5px;\n  margin: 10px;\n  cursor: pointer;\n}\n\n.swiper-button-next.hidden,\n.swiper-button-prev.hidden {\n  display: none;\n}\n\n.swiper-button-disabled {\n  opacity: 0;\n  display: none;\n}\n\n.slider {\n  --swiper-pagination-color: white;\n  --swiper-pagination-bullet-opacity: 1;\n  --swiper-navigation-color: white;\n  --swiper-navigation-size: 15px;\n}\n\n//#endregion hint\n","@mixin unselectable {\n  user-select: none !important;\n  -webkit-user-select: none !important;\n  -webkit-touch-callout: none !important;\n  -moz-user-select: none !important;\n  -ms-user-select: none !important;\n}\n\n@mixin background-footer-menu {\n  background: var(--footer-menu-background);\n  backdrop-filter: blur(var(--footer-menu-blur));\n  -webkit-backdrop-filter: blur(var(--footer-menu-blur));\n}\n\n@mixin background-nav-button {\n  --background: var(--footer-menu-background);\n  backdrop-filter: blur(var(--footer-menu-blur));\n  -webkit-backdrop-filter: blur(var(--footer-menu-blur));\n}\n\n@mixin text-clamp($str-count) {\n  display: -webkit-box;\n  -webkit-line-clamp: $str-count;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
